// assets/nd-my-quotes-v7-split.js
// My Quotes (Account page) — v7 split (Route A) [FIXED v7.3 - Draft delete uses quotation_no]
// - Runs ONLY on /account
// - Injects TWO blocks under the native Account section: My Quotes (Final) + Quote Draft (Draft)
// - Each row has actions: Open Detail + Delete (SOFT delete)
// - Detail URL uses /pages/quotedetail?quoteId=...
// - Delete = calls GAS action=delete => Google Sheet keeps row, sets Deleted=Y, UI removes it
//
// v7.3 FIX:
// ✅ Draft delete now sends quotation_no (DRAFT-xxxx) to GAS so Deleted=Y will work (because GAS matches by quotation_no)
// ✅ Still sends row_id as backup param

(function () {
  if (window.__ND_MY_QUOTES_V7_SPLIT__) return;
  window.__ND_MY_QUOTES_V7_SPLIT__ = true;

  var TAG = '[ND][MY_QUOTES_V7_SPLIT]';
  function log(){ try{ console.log.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} }
  function warn(){ try{ console.warn.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} }

  function isQuotePage() {
  try {
    var p = (location.pathname || '').toLowerCase();
    return (
      p === '/account' ||
      p.indexOf('/account') === 0 ||
      p === '/pages/quote-history' ||
      p.indexOf('/pages/quote-history') === 0
    );
  } catch (e) { return false; }
}
if (!isQuotePage()) return;

  var body = document.body;
  if (!body) return;

  var apiUrl = body.getAttribute('data-quotes-api-url') || '';
  var apiKey = body.getAttribute('data-quotes-api-key') || '';
  var customerEmail = body.getAttribute('data-customer-email') || '';
  var customerTags = body.getAttribute('data-customer-tags') || '';

  if (!apiUrl || !apiKey) { warn('Missing data-quotes-api-url / data-quotes-api-key on <body>. Abort.'); return; }
  if (!customerEmail) { warn('Missing data-customer-email on <body>. (Not logged in?) Abort.'); return; }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c == null) return;
      if (typeof c === 'string') n.appendChild(document.createTextNode(c));
      else n.appendChild(c);
    });
    return n;
  }

  function safeJsonParse(s){ try{ return JSON.parse(s); }catch(e){ return null; } }

  function fmtDate(s) {
    if (!s) return '';
    try {
      var d = new Date(s);
      if (isNaN(d.getTime())) return String(s);
      return d.toLocaleString(undefined, { year:'numeric', month:'2-digit', day:'2-digit' });
    } catch (e) { return String(s); }
  }

  function normalizeListResponse(res) {
    if (!res) return [];
    var list = null;
    if (Array.isArray(res)) list = res;
    else if (Array.isArray(res.data)) list = res.data;
    else if (Array.isArray(res.rows)) list = res.rows;
    else if (Array.isArray(res.items)) list = res.items;
    else if (res.data && Array.isArray(res.data.items)) list = res.data.items;
    return Array.isArray(list) ? list : [];
  }

  function apiGet(params) {
    var usp = new URLSearchParams();
    Object.keys(params || {}).forEach(function (k) {
      if (params[k] == null) return;
      usp.set(k, String(params[k]));
    });
    if (!usp.get('key')) usp.set('key', apiKey);
    var url = apiUrl + (apiUrl.indexOf('?') >= 0 ? '&' : '?') + usp.toString();

    return fetch(url, { method:'GET', credentials:'omit' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var j = safeJsonParse(t);
        if (j) return j;
        try {
          var idx = t.indexOf('{');
          if (idx >= 0) {
            var j2 = safeJsonParse(t.slice(idx));
            if (j2) return j2;
          }
        } catch(e) {}
        return { ok:false, raw:t };
      });
  }

  function findAccountAnchor() {
    var main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;

    var accountWrap =
      document.querySelector('.customer') ||
      document.querySelector('.account') ||
      document.querySelector('[data-template="customers/account"]') ||
      main;

    var accountTitle =
      accountWrap.querySelector('h1, h2, .customer__title, .account__title');

    if (accountTitle) {
      var section = accountTitle.closest('section') || accountTitle.closest('div') || accountWrap;
      return section;
    }
    return accountWrap;
  }

  function findOrCreateRoot() {
    var existing = document.getElementById('nd-my-quotes-root');
    if (existing) return existing;

    var anchor = findAccountAnchor();
    var root = el('div', { id:'nd-my-quotes-root' });

    try {
      if (anchor && anchor.parentNode) {
        if (anchor.nextSibling) anchor.parentNode.insertBefore(root, anchor.nextSibling);
        else anchor.parentNode.appendChild(root);
      } else {
        (document.querySelector('main') || document.body).appendChild(root);
      }
    } catch(e) {
      document.body.appendChild(root);
    }
    return root;
  }

  function injectStylesOnce() {
    if (document.getElementById('nd-my-quotes-style')) return;
    var css = [
      '#nd-my-quotes-root{max-width:1100px;margin:28px auto;padding:0 16px;}',
      '.ndq-block{border:1px solid rgba(0,0,0,.10);border-radius:18px;padding:18px 18px 10px;margin:18px 0;background:#fff;box-shadow:0 14px 34px rgba(0,0,0,.10);}',
      '.ndq-block:hover{box-shadow:0 18px 44px rgba(0,0,0,.12);}',
      '.ndq-title{font-size:28px;font-weight:800;margin:0 0 12px;}',
      '.ndq-table{width:100%;border-collapse:collapse;}',
      '.ndq-th{font-size:14px;letter-spacing:.5px;opacity:.7;text-align:left;padding:10px 8px;border-bottom:1px solid rgba(0,0,0,.10);}',
      '.ndq-td{padding:12px 8px;border-bottom:1px solid rgba(0,0,0,.06);vertical-align:middle;}',
      '.ndq-row-title{font-weight:800;}',
      '.ndq-muted{opacity:.75;font-size:13px;}',
      '.ndq-actions{display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap;}',
      '.ndq-btn{border:1px solid rgba(0,0,0,.18);background:#fff;border-radius:10px;padding:8px 12px;cursor:pointer;font-size:14px;line-height:1;}',
      '.ndq-btn.primary{border-color:rgba(0,0,0,.45);font-weight:800;}',
      '.ndq-btn.danger{border-color:rgba(255,0,0,.25);color:#b00000;opacity:1;cursor:pointer;}',
      '.ndq-btn.danger:hover{background:rgba(255,0,0,.06);}',
      '.ndq-btn[aria-disabled="true"]{opacity:.45;cursor:not-allowed;}',
      '.ndq-empty{padding:14px;border:1px dashed rgba(0,0,0,.2);border-radius:14px;opacity:.8;margin-top:8px;}',
      '.ndq-spinner{display:inline-block;width:14px;height:14px;border:2px solid rgba(0,0,0,.2);border-top-color:rgba(0,0,0,.6);border-radius:50%;animation:ndqspin .8s linear infinite;vertical-align:-2px;}',
      '@keyframes ndqspin{to{transform:rotate(360deg)}}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'nd-my-quotes-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function pickField(row, keys) {
    for (var i=0;i<keys.length;i++){
      var k = keys[i];
      if (row && row[k] != null && String(row[k]).trim() !== '') return row[k];
    }
    return '';
  }

  function normStr(v){ return String(v == null ? '' : v).trim(); }
  function normType(v){
    var s = normStr(v).toLowerCase();
    if (s === 'final') return 'final';
    if (s === 'draft') return 'draft';
    if (s.indexOf('final') >= 0) return 'final';
    if (s.indexOf('draft') >= 0) return 'draft';
    return s;
  }

  function normalizeRow(row) {
    var quotationNo = normStr(pickField(row, ['quotation_no','quotationNo','quote_no','quoteNo']));
    var rowId = normStr(pickField(row, ['row_id','rowId','id']));

    var fileTypeRaw = pickField(row, ['file_type','fileType','type','status']);
    var fileType = normType(fileTypeRaw);

    var created = pickField(row, ['created_date','createdDate','created_at','createdAt','timestamp']);
    var finalized = pickField(row, ['finalized_at','finalizedAt']);
    var reference = pickField(row, ['reference_numb','reference_no','referenceNum','reference','#reference']);

    var draftName = pickField(row, ['draft_name','draftName','name','title']);
    var status = pickField(row, ['status']);

    var displayIdFinal = quotationNo || rowId || '-';
    var displayDraftName = normStr(draftName) || rowId || quotationNo || '-';

    return {
      raw: row,
      quotationNo: quotationNo,
      rowId: rowId,
      idFinal: displayIdFinal,
      draftTitle: displayDraftName,
      fileType: fileType,
      fileTypeRaw: normStr(fileTypeRaw),
      created: created,
      finalized: finalized,
      reference: normStr(reference),
      status: normStr(status)
    };
  }

  function buildDetailUrl(quoteId) {
    if (!quoteId) return '/pages/quotedetail';
    return '/pages/quotedetail?quoteId=' + encodeURIComponent(quoteId);
  }

  var root = findOrCreateRoot();
  injectStylesOnce();

  var blockFinal = el('div', { class:'ndq-block', 'data-block':'final' }, [
    el('div', { class:'ndq-title', text:'My Quotes' }),
    el('div', { class:'ndq-muted', html:'<span class="ndq-spinner"></span> Loading…' })
  ]);

  var blockDraft = el('div', { class:'ndq-block', 'data-block':'draft' }, [
    el('div', { class:'ndq-title', text:'Quote Draft' }),
    el('div', { class:'ndq-muted', html:'<span class="ndq-spinner"></span> Loading…' })
  ]);

  root.appendChild(blockFinal);
  root.appendChild(blockDraft);

  var STATE = { final:[], draft:[], loading:true, error:'' };

  function renderFinal() {
    blockFinal.innerHTML = '';
    blockFinal.appendChild(el('div', { class:'ndq-title', text:'My Quotes' }));

    var mapped = (STATE.final || []).map(normalizeRow);

    if (STATE.error) {
      blockFinal.appendChild(el('div', { class:'ndq-empty', text:STATE.error }));
      return;
    }
    if (!mapped.length) {
      blockFinal.appendChild(el('div', { class:'ndq-empty', text:'No final quotes yet.' }));
      return;
    }

    var table = el('table', { class:'ndq-table' });
    table.appendChild(el('thead', null, [
      el('tr', null, [
        el('th', { class:'ndq-th', text:'Quote ID' }),
        el('th', { class:'ndq-th', text:'Reference #' }),
        el('th', { class:'ndq-th', text:'Date' }),
        el('th', { class:'ndq-th', text:'Delete', style:'text-align:right;' })
      ])
    ]));

    var tbody = el('tbody');
    mapped.forEach(function (x) {
      var quoteIdForOpen = x.quotationNo || x.rowId || '';
      var quoteIdForDelete = x.quotationNo || x.rowId || '';

      var tr = el('tr', { 'data-quoteid': quoteIdForOpen });

      tr.appendChild(el('td', { class:'ndq-td' }, [
        el('div', { class:'ndq-row-title', text: (x.idFinal || '-') })
      ]));

      tr.appendChild(el('td', { class:'ndq-td' }, [
        el('div', { text: (x.reference || '-') })
      ]));

      tr.appendChild(el('td', { class:'ndq-td' }, [
        el('div', { text: fmtDate(x.finalized || x.created) || '-' })
      ]));

      var actions = el('div', { class:'ndq-actions' }, [
        el('button', { class:'ndq-btn primary', type:'button', 'data-act':'open', 'data-id': quoteIdForOpen }, ['Open Detail']),
        el('button', { class:'ndq-btn danger', type:'button', 'data-act':'delete', 'data-id': quoteIdForDelete, 'data-rowid': (x.rowId || ''), title:'Delete (soft delete)' }, ['🗑'])
      ]);

      tr.appendChild(el('td', { class:'ndq-td', style:'text-align:right;' }, [actions]));
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    blockFinal.appendChild(table);
  }

  function renderDraft() {
    blockDraft.innerHTML = '';
    blockDraft.appendChild(el('div', { class:'ndq-title', text:'Quote Draft' }));

    var mapped = (STATE.draft || []).map(normalizeRow);

    if (STATE.error) {
      blockDraft.appendChild(el('div', { class:'ndq-empty', text:STATE.error }));
      return;
    }
    if (!mapped.length) {
      blockDraft.appendChild(el('div', { class:'ndq-empty', text:'No drafts yet.' }));
      return;
    }

    var table = el('table', { class:'ndq-table' });
    table.appendChild(el('thead', null, [
      el('tr', null, [
        el('th', { class:'ndq-th', text:'Draft Name' }),
        el('th', { class:'ndq-th', text:'Date' }),
        el('th', { class:'ndq-th', text:'Delete', style:'text-align:right;' })
      ])
    ]));

    var tbody = el('tbody');
    mapped.forEach(function (x) {
      // ✅ Open detail：優先 row_id（你 quotedetail 通常吃 row_id）
      var quoteIdForOpen = x.rowId || x.quotationNo || '';

      // ✅ Draft delete：一定要送 quotation_no（DRAFT-xxxx），GAS 才會用 quotation_no 命中寫 Deleted=Y
      // fallback：如果真的沒 quotation_no 才用 row_id
      var quoteIdForDelete = x.quotationNo || x.rowId || '';

      var tr = el('tr', { 'data-quoteid': quoteIdForOpen });

      tr.appendChild(el('td', { class:'ndq-td' }, [
        el('div', { class:'ndq-row-title', text: (x.draftTitle || '-') })
      ]));

      tr.appendChild(el('td', { class:'ndq-td' }, [
        el('div', { text: fmtDate(x.created) || '-' })
      ]));

      var actions = el('div', { class:'ndq-actions' }, [
        el('button', { class:'ndq-btn primary', type:'button', 'data-act':'open', 'data-id': quoteIdForOpen }, ['Open Detail']),
        // ✅ data-id = quotation_no for delete; keep data-rowid as backup
        el('button', { class:'ndq-btn danger', type:'button', 'data-act':'delete', 'data-id': quoteIdForDelete, 'data-rowid': (x.rowId || ''), title:'Delete (soft delete)' }, ['🗑'])
      ]);

      tr.appendChild(el('td', { class:'ndq-td', style:'text-align:right;' }, [actions]));
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    blockDraft.appendChild(table);
  }

  function removeFromStateById(id) {
    function keepRow(r){
      var n = normalizeRow(r);
      return (n.quotationNo !== id && n.rowId !== id);
    }
    STATE.final = (STATE.final || []).filter(keepRow);
    STATE.draft = (STATE.draft || []).filter(keepRow);
  }

  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!btn) return;

    var act = btn.getAttribute('data-act');
    var id = (btn.getAttribute('data-id') || '').trim();
    var rowidBackup = (btn.getAttribute('data-rowid') || '').trim();
    if (!act || !id) return;

    if (act === 'open') {
      location.href = buildDetailUrl(id);
      return;
    }

    if (act === 'delete') {
      e.preventDefault();
      e.stopPropagation();

      if (btn.getAttribute('aria-disabled') === 'true') return;

      var ok = confirm('Delete this quote?\n(Deleted Info can not be restored.)');
      if (!ok) return;

      try { btn.setAttribute('aria-disabled','true'); btn.disabled = true; } catch(_) {}

      // GAS markDeleted_ matches by quotation_no column, so for Draft we MUST send quotation_no.
      // We also send row_id as backup in case you later enhance GAS to match row_id too.
      apiGet({
        action: 'delete',
        quote_id: id,
        quotation_no: id,
        row_id: rowidBackup || '',
        email: customerEmail,
        customer_email: customerEmail
      }).then(function (res) {
        if (!res || res.ok !== true) {
          throw new Error((res && (res.error || res.message)) ? (res.error || res.message) : 'Delete failed');
        }

        removeFromStateById(id);
        // also remove by row_id backup if needed (UI cleanliness)
        if (rowidBackup) removeFromStateById(rowidBackup);

        renderFinal();
        renderDraft();
      }).catch(function (err) {
        alert('Delete failed: ' + (err && err.message ? err.message : String(err)));
      }).finally(function () {
        try { btn.removeAttribute('aria-disabled'); btn.disabled = false; } catch(_) {}
      });

      return;
    }
  });

  function splitByFileType(allRows){
    var mapped = (allRows || []).map(normalizeRow);
    var drafts = mapped.filter(function (x) { return x.fileType === 'draft'; }).map(function(x){ return x.raw; });
    var finals = mapped.filter(function (x) { return x.fileType === 'final'; }).map(function(x){ return x.raw; });
    return { draft: drafts, final: finals };
  }

  function fetchAll() {
    STATE.loading = true;
    STATE.error = '';

    Promise.all([
      apiGet({ action:'list', email: customerEmail, tags: customerTags, type:'Draft' }),
      apiGet({ action:'list', email: customerEmail, tags: customerTags, type:'Final' })
    ]).then(function (arr) {
      var resDraft = arr[0];
      var resFinal = arr[1];

      var listDraft = normalizeListResponse(resDraft);
      var listFinal = normalizeListResponse(resFinal);

      STATE.draft = listDraft;
      STATE.final = listFinal;

      var suspiciousSame =
        listDraft && listFinal &&
        listDraft.length && listFinal.length &&
        listDraft.length === listFinal.length;

      var onlyOneSideHas =
        ((!listDraft || !listDraft.length) && (listFinal && listFinal.length)) ||
        ((!listFinal || !listFinal.length) && (listDraft && listDraft.length));

      if (suspiciousSame || onlyOneSideHas) {
        var merged = [];
        try { merged = (listDraft || []).concat(listFinal || []); }
        catch(e) { merged = listDraft || listFinal || []; }

        var seen = {};
        var uniq = [];
        (merged || []).forEach(function(r){
          var n = normalizeRow(r);
          var key = n.rowId || n.quotationNo || JSON.stringify(r);
          if (seen[key]) return;
          seen[key] = 1;
          uniq.push(r);
        });

        var sp = splitByFileType(uniq);
        if (sp.draft.length || sp.final.length) {
          STATE.draft = sp.draft;
          STATE.final = sp.final;
        }
      }

    }).catch(function (e) {
      STATE.error = (e && e.message) ? e.message : String(e || 'Unknown error');
    }).finally(function () {
      STATE.loading = false;
      renderFinal();
      renderDraft();
    });
  }

  log('init', { apiUrl: apiUrl, customerEmail: customerEmail, tags: customerTags });
  fetchAll();
})();
